// Central, environment-aware config for the backend the frontend talks to.
// REACT_APP_ENV is injected by the deploy scripts (`production` | `staging`);
// it is unset for local `npm start` (where NODE_ENV is `development`).
export const APP_ENV: string =
  process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

// Absolute backend origin per environment. Used for media/document URLs, and
// (in production) for direct API calls. An explicit REACT_APP_API_BASE_URL wins.
const BACKEND_ORIGIN_BY_ENV: Record<string, string> = {
  production: 'https://dmp.agrivcs.co.za',
  staging: 'https://stag-env.agrivcs.co.za',
};

// The absolute backend origin this build targets. Always resolvable, even when
// API traffic is proxied (staging/dev), so media/document URLs can be normalised.
export const BACKEND_ORIGIN: string =
  process.env.REACT_APP_API_BASE_URL ||
  BACKEND_ORIGIN_BY_ENV[APP_ENV] ||
  'https://stag-env.agrivcs.co.za';

// API base URL for requests:
//  - production: call the production backend directly (cross-origin — the prod
//    backend's CORS_ALLOWED_ORIGINS must include https://portal.agrivcs.co.za).
//  - staging/dev: empty string => relative `/api` paths, forwarded by nginx
//    (staging) or the CRA dev proxy (setupProxy.js, dev).
// An explicit REACT_APP_API_BASE_URL always overrides.
export const API_BASE_URL: string =
  process.env.REACT_APP_API_BASE_URL ||
  (APP_ENV === 'production' ? BACKEND_ORIGIN_BY_ENV.production : '');

// When empty, requests use relative /api paths (proxy handles routing/CORS).
export const USE_PROXY = API_BASE_URL === '';

// Origin used to normalise media/document URLs returned by the API.
export const MEDIA_ORIGIN = BACKEND_ORIGIN;
